import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-so-sorry',
  templateUrl: './so-sorry.component.html',
  styleUrls: ['./so-sorry.component.scss'],
})
export class SoSorryComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/so-sorry/so-sorry.component.ts